import { EmptyEditor } from './EmptyEditor';

export default EmptyEditor;
